import { render, staticRenderFns } from "./thanks-letter-poster-2020.vue?vue&type=template&id=0ad0d01f&scoped=true&"
import script from "./thanks-letter-poster-2020.vue?vue&type=script&lang=js&"
export * from "./thanks-letter-poster-2020.vue?vue&type=script&lang=js&"
import style0 from "./thanks-letter-poster-2020.vue?vue&type=style&index=0&id=0ad0d01f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad0d01f",
  null
  
)

export default component.exports